var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'verified-badge' + _vm.getSizeClass},[(_vm.showTooltip)?_c('el-tooltip',{attrs:{"effect":"dark","placement":"top","content":"This artist has been verified"}},[_c('img',{attrs:{"src":"/img/icons/verified-badge.png","alt":"Verified badge"}})]):_c('img',{attrs:{"src":"/img/icons/verified-badge.png"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }